import Message from '@/modules/Chat/components/Message/Message.tsx';
import Header from '@/modules/Chat/components/Message/components/Header';

export default { Root: Message, Header };
